class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.isMegaMenu = this.mainDetailsToggle.classList.contains('mega-menu');
    this.hoverMediaQuery = window.matchMedia('(min-width: 990px) and (hover: hover)');
    this.hoverCloseTimeout = null;

    if (this.isMegaMenu) {
      this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
    }
  }

  onSummaryClick(event) {
    if (this.hoverMediaQuery.matches && event.detail !== 0) {
      event.preventDefault();
    }
  }

  onMouseEnter() {
    if (!this.hoverMediaQuery.matches) return;

    clearTimeout(this.hoverCloseTimeout);
    this.open();
    this.closeOtherMegaMenus();
  }

  onMouseLeave() {
    if (!this.hoverMediaQuery.matches) return;

    this.hoverCloseTimeout = setTimeout(() => this.close(), 150);
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
  }

  closeOtherMegaMenus() {
    document.querySelectorAll('header-menu .mega-menu[open]').forEach((details) => {
      if (details !== this.mainDetailsToggle) {
        details.closest('header-menu')?.close();
      }
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
